import React from 'react';
import { withStyles } from "@material-ui/core/styles";
import { Snackbar, SnackbarContent } from '@material-ui/core';
import { Error as ErrorIcon, Info as InfoIcon, Warning as WarningIcon, CheckCircle as CheckCircleIcon } from '@material-ui/icons';
import { green, amber } from '@material-ui/core/colors';
import classNames from 'classnames';

const variantIcon = {
  success: CheckCircleIcon,
  warning: WarningIcon,
  error: ErrorIcon,
  info: InfoIcon,
};

const styles = theme => ({
  success: {
    backgroundColor: green[600],
  },
  error: {
    backgroundColor: theme.palette.error.dark,
  },
  info: {
    backgroundColor: theme.palette.primary.dark,
  },
  warning: {
    backgroundColor: amber[700],
  },
  icon: {
    fontSize: 20,
  },
  iconVariant: {
    opacity: 0.9,
    marginRight: theme.spacing(1),
  },
  message: {
    display: 'flex',
    alignItems: 'center',
  },
  margin: {
    margin: theme.spacing(1),
  }
});

const CustomSnackbar = (props) => {
  const { classes, vertical = 'top', horizontal = 'center' } = props;
  const Icon = variantIcon[props.type];

  return (
    <Snackbar
      anchorOrigin={{
        vertical: vertical,
        horizontal: horizontal,
      }}
      onClose={() => props.closeSnackbar()}  //{(props) => handleClose(props)}
      open={props.open}
      autoHideDuration={5000}
    >
      <SnackbarContent
        className={classNames(classes[props.type], classes.margin)}
        aria-describedby="client-snackbar"
        message={
          <span id="client-snackbar" className={classes.message}>
            <Icon className={classNames(classes.icon, classes.iconVariant)} />
            {props.message}
          </span>
        }
      />
    </Snackbar>
  );
}

export default withStyles(styles)(CustomSnackbar);